module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "card "
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('router-link', {
    attrs: {
      "to": '../' + _vm.workflowId
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-secondary",
    staticStyle: {
      "margin-right": "12px"
    },
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])]), _vm._v(" "), _c('strong', [_vm._v("Preview do workflow")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDiagram),
      expression: "showDiagram"
    }],
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "id": "downloadPreview",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.download($event)
      }
    }
  }, [_vm._v("\n            Download\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDiagram),
      expression: "showDiagram"
    }],
    staticStyle: {
      "height": "450px",
      "margin-top": "15px"
    },
    attrs: {
      "id": "bpmnDiagram"
    }
  })])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d4c20652", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4c20652"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/beast/workflows/VersionsPreview.vue
// module id = 1582
// module chunks = 1